const exportedObject = {
  crearMedicamentoData: {},
  crearMedicamentoLoading: false,
  crearMedicamentoError: null,

  cancelarMedicamentoData: {},
  cancelarMedicamentoLoading: false,
  cancelarMedicamentoError: null,

  getMedicamentoData: {},
  getMedicamentoLoading: false,
  getMedicamentoError: null,

  consultarMedicamentosData: {},
  consultarMedicamentosLoading: false,
  consultarMedicamentosError: null,

  reactivarMedicamentoData: {},
  reactivarMedicamentoLoading: false,
  reactivarMedicamentoError: null,

  limpiarDatosMedicamentoLoading: false,

  formMedicamentoDiagnosticoData: {
    numeroBusqueda: "",
    fechaInicio: "",
    fechaFin: "",
    medicamentos: [],
    diagnostico: "",
    diagnosticoModificar: null,
    showAlert: false,
    alertConfig: {},
    showModalModificarDiagnostico: false,
  },

  formMedicamentoDiagnosticoLoading: false,

  getMedicamentosDiagnosticoLoading: false,

  modificarDiagnosticoDefinitivoLoading: false,

  confirmarDiagnosticoDefinitivoLoading: false,

  descargarReporteVoucherLoading: false,
  descargarReporteVoucherData: {},

  buscarMedicamentosOrdsInfoplanData: {},
  buscarMedicamentosOrdsInfoplanLoading: false,
  buscarMedicamentosOrdsInfoplanError: null,

  notificarReclamacionData: {},
  notificarReclamacionLoading: false,
  notificarReclamacionError: null,
};

export default exportedObject;

